import React, { useEffect, useRef } from 'react';
import { useAccount } from '../account/AccountContext.jsx';
import { loadAdsIfAllowed } from '../account/adsGate';

// One manual AdSense unit. The markup is the same for every visitor (so it
// matches the prerendered HTML); for Spark & Spiral Plus members CSS hides
// `.ad-slot` (html.spark-plus, set in index.html before first paint) and the
// unit is never pushed, so no ad request is made.
//
// `className` / `style` style the wrapper exactly as each page did before.
// `pushKey` re-requests the unit when it changes (e.g. the blog post slug).
// `domGuard` keeps the old /play and /crowns-puzzle behaviour: the "pushed"
// mark is a data attribute, which the prerender captures, so on a direct load
// those units are not pushed (only after in-app navigation). Other pages mark
// the element in memory and push on every mount. Kept as is so ad loading for
// non-members does not change with this PR.
const pushedInMemory = new WeakSet();

function AdSlot({ className, style, pushKey = '', domGuard = false }) {
  const ref = useRef(null);
  const { adsEnabled } = useAccount();

  useEffect(() => {
    const el = ref.current;
    // A new pushKey mounts a fresh <ins> (it is the element's key).
    if (!el || !adsEnabled) return;
    if (domGuard) {
      if (el.dataset.adPushed) return;
      el.dataset.adPushed = 'true';
    } else {
      if (pushedInMemory.has(el)) return;
      pushedInMemory.add(el);
    }
    if (!loadAdsIfAllowed()) return;
    let attempts = 0;
    const tryPush = () => {
      attempts += 1;
      if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
        try { window.adsbygoogle.push({}); } catch (e) { /* ignore */ }
        return;
      }
      if (attempts < 5) setTimeout(tryPush, 500);
    };
    tryPush();
  }, [adsEnabled, pushKey, domGuard]);

  return (
    <div className={className ? `${className} ad-slot` : 'ad-slot'} style={style}>
      <ins
        ref={ref}
        key={pushKey}
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8753462308649653"
        data-ad-slot="2534228211"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}

export default AdSlot;
